module.exports = __webpack_public_path__ + "static/img/wrong-icon.2d436c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wrong-icon.png
// module id = bxPd
// module chunks = 36